module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showMessage) ? _c('messageModal', {
    attrs: {
      "message": "votre avatar a été mis à jour !"
    },
    on: {
      "closeMessage": function($event) {
        _vm.showMessage = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-3 large-centered columns"
  }, [_c('imageEditor', {
    ref: "imgEditor",
    attrs: {
      "imageSrc": _vm.getImageSrc
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.validate()
      }
    }
  }, [_vm._v("valider")])])]), _vm._v(" "), _c('br')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_vm._v(" \n            Choisissez votre avatar en cliquant sur l'image \n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8c760e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/my-account/my-infos.vue
// module id = 775
// module chunks = 0